import mainReducer from './reducers';
import searchMiddleware from './search/apiMiddleware';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

const logger = store => next => action => {
  //console.log('dispatching', action)
  let result = next(action)
  //console.log('next state', store.getState())
  return result
}


let store = createStore(
	mainReducer,
	applyMiddleware( logger, searchMiddleware, thunk ));



store.subscribe(() => {
  var state = store.getState();

});

export default store;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/store.js